import * as ff from '../constants/FormFields';
import * as VN from '../constants/VendorNames';

const customData = {
    // Authentication
    [ff.AUTH_PAYMENT_TYPE]: 'VIRTUAL',
    //101 2nd St
    [ff.AUTH_BILLING_ADDRESS]: '',
    //'5119130016376739'
    [ff.AUTH_CARD_NUMBER]: '',
    // San Francisco
    // [ff.AUTH_CITY]: '',
    //'255'
    [ff.AUTH_CVV] : '',
    //0823
    [ff.AUTH_EXPIRATION_DATE]: '',
    // [ff.AUTH_COUNTRY]: 'US',
    [ff.AUTH_ZIPCODE]: '94105',
    [ff.AUTH_PIN ]: '1111',
    [ff.AUTH_SERVICE_CODE]: '123',
    // Merchant
    [ff.MERCH_PLATFORM_NAME]: 'BitReady LTD',
    [ff.MERCH_ADDRESS]: '100 Main St.',
    [ff.MERCH_CITY]: 'Syracuse',
    [ff.MERCH_STATE]: 'NY',
    [ff.MERCH_COUNTRY]: 'US',
    // Transaction
    [ff.TRANS_CURRENCY]: 'USD',
    [ff.TRANS_AMOUNT]: 10,
    [ff.TRANS_ID]: '123',
    [ff.TRANS_TYPE]: 'PURCHASE',
    [ff.TRANS_CONVERSION_RATE]: '1.2',
    [ff.TRANS_MCC]: '6211',
    [ff.TRANS_RECURRING]: 'false',
    [ff.META_NETWORK_ID ]: 'PUL',
    [ff.META_LIFECYCLE]: 2,
    [ff.META_LIFECYCLE_INT]: 'DAYS',
    [ff.META_TERMINAL_ID]: '100'
}

const venmoData = {
    "amount": {
        "debit": true,
        "transaction_currency":"USD",
        "transaction_value": 2.5,
        "settlement_currency":"USD",
        "settlement_currency_conversion_rate": "1.2",
        "settlement_value":0,
    }
}

const paypalData = {
    "amount":{
        "debit":true,
        "transaction_currency":"cUSD",
        "transaction_value":100,
        "settlement_currency":"cUSD",
        "settlement_currency_conversion_rate":null,
        "settlement_value":100,
     }
}

const wholefoodsData = {

}

const amazonData = {

}

const gasData = {
    "amount":{
        "debit":true,
        "transaction_currency":"cUSD",
        "transaction_value":355,
        "settlement_currency":"cUSD",
        "settlement_currency_conversion_rate":null,
        "settlement_value":355,
    }
}

const greendotData = {

}

const atmData = {

}

const uberData = {
    "amount":{
        "debit":true,
        "transaction_currency":"cUSD",
        "transaction_value":0,
        "settlement_currency":"cUSD",
        "settlement_currency_conversion_rate":null,
        "settlement_value":0,
     }
}

const prepopulate = {
    [VN.CUSTOM]: customData,
    [VN.VENMO]: venmoData,
    [VN.PAYPAL]: paypalData,
    [VN.WHOLE_FOODS]: wholefoodsData,
    [VN.AMAZON]: amazonData,
    [VN.GAS_STATION]: gasData,
    [VN.GREEN_DOT]: greendotData,
    [VN.ATM]: atmData,
    [VN.UBER]: uberData
}

export default prepopulate;